(function(){
  function init(section){
    if(!section||section.dataset.startHereReady==='true')return;
    section.dataset.startHereReady='true';
    section.querySelectorAll('[data-faq-toggle]').forEach(function(button){
      button.addEventListener('click',function(){
        var expanded=button.getAttribute('aria-expanded')==='true';
        var answer=document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded',String(!expanded));
        if(answer)answer.hidden=expanded;
      });
    });
    section.querySelectorAll('[data-klaviyo-form-trigger]').forEach(function(button){
      button.addEventListener('click',function(){
        var formId=button.dataset.klaviyoFormId;
        if(!formId)return;
        window._klOnsite=window._klOnsite||[];
        window._klOnsite.push(['openForm',formId]);
      });
    });
    var quiz=section.querySelector('[data-start-here-quiz]');
    if(!quiz)return;
    var steps=Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-step]'));
    var results=Array.prototype.slice.call(quiz.querySelectorAll('[data-result-key]'));
    var progress=quiz.querySelector('[data-quiz-progress]');
    var answers={};
    function showStep(index){
      steps.forEach(function(step,i){step.hidden=i!==index;});
      quiz.querySelector('[data-quiz-result]').hidden=true;
      if(progress)progress.textContent='Question '+(index+1)+' of '+steps.length;
    }
    function showResult(){
      var key=(answers.usecase||'everyday')+'_'+(answers.occasion||'self')+'_'+(answers.exploration||'favorite');
      steps.forEach(function(step){step.hidden=true;});
      results.forEach(function(result){result.hidden=result.dataset.resultKey!==key;});
      quiz.querySelector('[data-quiz-result]').hidden=false;
      if(progress)progress.textContent='Your recommendation';
      quiz.querySelector('[data-quiz-result]').scrollIntoView({behavior:'smooth',block:'nearest'});
    }
    quiz.querySelectorAll('[data-answer]').forEach(function(button){
      button.addEventListener('click',function(){
        var step=Number(button.closest('[data-quiz-step]').dataset.quizStep);
        answers[button.dataset.question]=button.dataset.answer;
        button.closest('[data-quiz-step]').querySelectorAll('[data-answer]').forEach(function(option){option.setAttribute('aria-pressed',String(option===button));});
        if(step<steps.length-1)showStep(step+1);else showResult();
      });
    });
    quiz.querySelectorAll('[data-quiz-back]').forEach(function(button){button.addEventListener('click',function(){showStep(Math.max(0,Number(button.closest('[data-quiz-step]').dataset.quizStep)-1));});});
    quiz.querySelectorAll('[data-quiz-reset]').forEach(function(button){button.addEventListener('click',function(){answers={};quiz.querySelectorAll('[data-answer]').forEach(function(option){option.setAttribute('aria-pressed','false');});showStep(0);});});
    showStep(0);
  }
  function initAll(root){(root||document).querySelectorAll('[data-start-here-section]').forEach(init);}
  document.addEventListener('DOMContentLoaded',function(){initAll(document);});
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();
